import turtleNeck from './turtleneck_stretching.gif';
import sideArmStretching from './side_arm_stretching.gif';
import sideNeck from './side_neck_stretching.gif';

export const poseImage = {
  TurtleNeck: turtleNeck,
  Arm: sideArmStretching,
  SideNeck: sideNeck,
};
